import moment from 'moment';
import 'moment/locale/ja';
import Ua from '../modules/ua';
// import schedule from '../../fixtures/area42';
// import MockAdapter from 'axios-mock-adapter';
// import networkJson from '../../fixtures/network.json';
import axios from 'axios'

const client = axios.create({
    timeout: 5000,
});

// const mockAxios = new MockAdapter(client);
// mockAxios.onGet(
//     'https://7d3a2vmwxf.execute-api.ap-northeast-1.amazonaws.com/prod/schedules/area?areaCd=42',
//     'https://7d3a2vmwxf.execute-api.ap-northeast-1.amazonaws.com/prod/schedules/area?areaCd=43'
// ).reply(200, schedule);
//
// mockAxios.onGet(
//     'https://7d3a2vmwxf.execute-api.ap-northeast-1.amazonaws.com/prod/broad_caster/relation?areaCd=42',
// ).reply(200, networkJson);

moment().locale('ja');

const BASE_CH_WIDTH = 105;
const TOP_X = Ua.isPcUser(navigator.userAgent) ? "122px" : "48px";
const TOP_Y = "0px"
const TOP_BAR_HEIGHT = Ua.isPcUser(navigator.userAgent) ? 168 : 94;
const TIME_BAR_WIDTH = "23px";

export default {
    setScrollStartPos() {
        window.scrollTo(0, 0);
        const _topBar = document.getElementById("top_ber");
        _topBar.style.left = TIME_BAR_WIDTH;
        _topBar.style.top = TOP_X;
        const _leftBar = document.getElementById("left_ber");
        _leftBar.style.left = TOP_Y;
        _leftBar.style.top = TOP_BAR_HEIGHT + 'px';
        const _contents = document.getElementById("contents");
        _contents.style.left = TIME_BAR_WIDTH;
        _contents.style.top = TOP_BAR_HEIGHT + 'px';
    },
    addCrossBarScrollEvent() {
        const _topBar = document.getElementById("top_ber");
        const _leftBar = document.getElementById("left_ber");
        const _left = _topBar.offsetLeft;
        const scrollDirection = function () {
            _topBar.style.left = (-1 * window.pageXOffset + _left) + 'px';
            _topBar.style.top = TOP_X;
            _leftBar.style.left = TOP_Y;
            _leftBar.style.top = (-1 * window.pageYOffset + TOP_BAR_HEIGHT) + 'px';
        }
        document.body.addEventListener('touchmove', function () {
            scrollDirection()
        }, false);
        window.addEventListener('scroll', function () {
            scrollDirection()
        }, false);
    },
    crossBarInfo(schedule, channelOrders) {
        const days = [];
        let channels = [];
        let topBarWidth = 0;
        const programs = [];
        const dailyWidth = {};
        let dateIndex = 0;
        Object.keys(schedule).forEach(date => {
            let chNames = Object.keys(schedule[date]).sort((a, b) => {
                return channelOrders[a] > channelOrders[b];
            });
            let chNum = chNames.length;
            if (chNum <= 0) return;
            channels = channels.concat(chNames);
            days.push({date: date, chNum: chNum, formatDate: moment(date).format("M月D日")});
            dailyWidth[date] = topBarWidth;
            topBarWidth += chNum * BASE_CH_WIDTH;
            chNames.forEach(chName => {
                programs.push({data: schedule[date][chName], dateIndex});
            });
            dateIndex += 1;
        });
        return {days, channels, topBarWidth, programs, dailyWidth};
    },
    calcProgramPos(startTime, endTime) {
        const dateStartTime = moment(startTime.substr(0, 8) + "0600", "YYYYMMDDHHmm");
        const _startTime = moment(startTime, "YYYYMMDDHHmm");
        const _endTime = moment(endTime, "YYYYMMDDHHmm");
        return {top: _startTime.diff(dateStartTime, 'minutes'), height: (_endTime.diff(_startTime, 'minutes') - 1)};
    },
    getSchedule(areaId) {
        return client.get('https://7d3a2vmwxf.execute-api.ap-northeast-1.amazonaws.com/prod/schedules/area?areaCd=' + areaId)
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    getBroadCasters(areaId) {
        return client.get('https://7d3a2vmwxf.execute-api.ap-northeast-1.amazonaws.com/prod/broad_caster/relation?areaCd=' + areaId)
            .then((res) => {
                return res.data;
            })
            .catch((error) => {
                console.log(error);
                return Promise.reject(error);
            });
    },
    getToday() {
        return moment().format("YYYYMMDD");
    },
    goSiPage(e, url) {
        e.preventDefault();
        if (url) {
            window.location.href = url;
        } else {
            alert("番組の詳細情報は放送7日前からご覧になれます。");
        }
        return;
    },
    updateScheduleAction(areaId) {
        this.getBroadCasters(areaId).then((broadCasters) => {
            const channelMaps = {};
            let channelOrders = {};
            for (var channel in broadCasters) {
                channelMaps[channel] = broadCasters[channel].name;
                channelOrders[channel] = broadCasters[channel].orderNo;
            }
            this.setState({
                channelMaps: channelMaps
            });
            this.getSchedule(areaId).then((scheduleData) => {
                const _crossBarInfo = this.crossBarInfo(scheduleData, channelOrders);
                this.setState({
                    dates: _crossBarInfo.days, channels: _crossBarInfo.channels, programs: _crossBarInfo.programs
                })
                document.getElementById("top_ber").style.width = _crossBarInfo.topBarWidth + 'px';
                document.getElementById("contents").style.width = _crossBarInfo.topBarWidth + 'px';
                const today = this.getToday();
                if (today in _crossBarInfo.dailyWidth) {
                    window.scrollTo(_crossBarInfo.dailyWidth[today], 0);
                }
            }, (error) => {
                console.log(error);
            });
        }, (error) => {
            console.log(error);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/mixins/olympic.js